import React from 'react';

const BONANZA_MIN = 25;

export function BonanzaPool({ pool = 0 }) {
  const progress = Math.min((pool / BONANZA_MIN) * 100, 100);
  const isReady = pool >= BONANZA_MIN;

  return (
    <div style={{
      background: '#0d0d0d',
      border: `1px solid ${isReady ? '#F0B800' : '#2a2a2a'}`,
      borderRadius: '10px',
      padding: '14px 16px',
      marginBottom: '12px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {isReady && (
        <div style={{
          position: 'absolute', inset: 0,
          background: 'rgba(240,184,0,0.04)',
          animation: 'bonanzaPulse 2s ease infinite',
        }} />
      )}
      <style>{`
        @keyframes bonanzaPulse {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }
      `}</style>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ fontFamily: "'DM Mono', monospace", fontSize: '13px', color: '#cccccc', letterSpacing: '2px' }}>
          🎰 PROGRESSIVE BONANZA POOL
        </div>
        {isReady && (
          <div style={{ fontFamily: "'DM Mono', monospace", fontSize: '10px', color: '#F0B800', letterSpacing: '1px', animation: 'bonanzaPulse 1s ease infinite' }}>
            READY!
          </div>
        )}
      </div>

      <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '32px', color: '#F0B800', letterSpacing: '2px', lineHeight: 1, marginBottom: 8 }}>
        {pool.toFixed(3)} SOL
      </div>

      <div style={{ background: '#1a1a1a', borderRadius: 4, height: 6, marginBottom: 6, overflow: 'hidden' }}>
        <div style={{
          height: '100%',
          width: `${progress}%`,
          background: isReady ? '#F0B800' : 'linear-gradient(90deg, #4CAF50, #F0B800)',
          borderRadius: 4,
          transition: 'width 0.5s ease',
        }} />
      </div>

      <div style={{ fontFamily: "'DM Mono', monospace", fontSize: '11px', color: '#ccc', display: 'flex', justifyContent: 'space-between' }}>
        <span>{isReady ? `🏆 Bonanza round unlocked!` : `${BONANZA_MIN - pool > 0 ? (BONANZA_MIN - pool).toFixed(1) : 0} SOL to unlock`}</span>
        <span>{pool.toFixed(1)}/{BONANZA_MIN} SOL</span>
      </div>

      {isReady && (
        <div style={{ marginTop: 8, fontFamily: "'DM Mono', monospace", fontSize: '10px', color: '#888', lineHeight: 1.6 }}>
          Top 90 players by squares purchased qualify.<br />
          Top 10 Chicken Droppings scores also qualify.
        </div>
      )}

      <div style={{ marginTop: 10, fontFamily: "'DM Mono', monospace", fontSize: '11px', color: '#aaa', lineHeight: 1.7, borderTop: '1px solid #1a1a1a', paddingTop: 8 }}>
        The BONANZA pool round is triggered once the pool reaches 25 SOL. Once triggered, a 30 minute countdown will commence and then the winner is selected from one of the top 100 chicken dropping players. Keep your eyes peeled to see if you're the winner!!
      </div>
    </div>
  );
}
